<template>
  <v-app id="app">

    <Header/>

    <div class="wrapper">
      <div class="content">
        <router-view/>
        <News/>
      </div>
    </div>

    <Footer/>

  </v-app>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    import News from './components/News'

    export default {
        name: 'App',
        components: {
            Header,
            News,
            Footer
        }
    }
</script>

<style lang="css">
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  html,body {
    height:100%;
    background-color: white;
  }
  ol, ul {

  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  body {
    font-family: 'Open Sans', sans-serif;
    font-weight:400;
    font-size:16px;
    line-height:26px;
    -moz-hyphens: auto;
    hyphens: auto;
  }
  body, div, span, h1, h2, h3, h4, h5, ul, li, main, header, article, footer {
    box-sizing: border-box;
  }
  h1, h2, h3, h4, h5 {
    font-family: 'PT Serif', serif;
    font-weight:400;
  }
  h1 {
    font-size:37px;
    line-height:45px;
    font-weight:400;
    color:#930303;
    margin-bottom:40px;
  }
  h2 {
    font-family: 'Open Sans', sans-serif;
    font-weight:400;
    font-size:28px;
    line-height:36px;
    color:#930303;
    margin-bottom:34px;
  }
  h3 {
    font-family: 'Open Sans', sans-serif;
    font-weight:400;
    font-size:22px;
    line-height:28px;
    color:#930303;
    margin-bottom:5px;
  }
  h4 {
    font-family: 'Open Sans', sans-serif;
    font-weight:600;
    font-size:8px;
    line-height:28px;
    color:#930303;
    margin-bottom:0px;
  }
  h4 i{
    font-weight:400;
  }
  strong {
    font-weight:600;
  }
  a {
    text-decoration:none;
    color:#930303;
  }
  a:hover {
    text-decoration:underline;
  }
  i {
    font-style:italic;
  }

  #app {
    margin-top: 0;
  }

  .wrapper {
    position:relative;
    margin:0 auto;
    width:1280px;
    background-color:white;
  }

  /* ---------------------------------------- Content Section */
  .content {
    display:table;
    box-sizing:border-box;
    padding:80px 150px;
    width: 100%;
  }

  @media only screen and (min-width: 1px) and (max-width: 1279px) {

    .wrapper {
      width:100%;
    }

    /* ---------------------------------------- Content Section */

    .content {
      padding:80px 8vw 80px 11.6vw;
    }
  }

  @media only screen and (min-width: 1px) and (max-width: 1059px) {
    .content {
      padding:80px 2vw 80px 4vw;
    }
  }

  @media only screen and (min-width: 1px) and (max-width: 799px) {
    .content {
      display:block;
    }
    .content {
      padding:45px 4vw 45px 4vw;
    }
  }

  /* pt-serif-regular - latin */
  @font-face {
    font-family: 'PT Serif';
    font-style: normal;
    font-weight: 400;
    src: url('fonts/pt-serif/pt-serif-v9-latin-regular.eot'); /* IE9 Compat Modes */
    src: local('PT Serif'), local('PTSerif-Regular'),
    url('fonts/pt-serif/pt-serif-v9-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/pt-serif/pt-serif-v9-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/pt-serif/pt-serif-v9-latin-regular.woff') format('woff'), /* Modern Browsers */
    url('fonts/pt-serif/pt-serif-v9-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/pt-serif/pt-serif-v9-latin-regular.svg#PTSerif') format('svg'); /* Legacy iOS */
  }

  /* pt-serif-700 - latin */
  @font-face {
    font-family: 'PT Serif';
    font-style: normal;
    font-weight: 700;
    src: url('fonts/pt-serif/pt-serif-v9-latin-700.eot'); /* IE9 Compat Modes */
    src: local('PT Serif Bold'), local('PTSerif-Bold'),
    url('fonts/pt-serif/pt-serif-v9-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/pt-serif/pt-serif-v9-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/pt-serif/pt-serif-v9-latin-700.woff') format('woff'), /* Modern Browsers */
    url('fonts/pt-serif/pt-serif-v9-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/pt-serif/pt-serif-v9-latin-700.svg#PTSerif') format('svg'); /* Legacy iOS */
  }

  /* lato-regular - latin */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: url('fonts/lato/lato-v14-latin-regular.eot'); /* IE9 Compat Modes */
    src: local('Lato Regular'), local('Lato-Regular'),
    url('fonts/lato/lato-v14-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/lato/lato-v14-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/lato/lato-v14-latin-regular.woff') format('woff'), /* Modern Browsers */
    url('fonts/lato/lato-v14-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/lato/lato-v14-latin-regular.svg#Lato') format('svg'); /* Legacy iOS */
  }

  /* lato-italic - latin */
  @font-face {
    font-family: 'Lato';
    font-style: italic;
    font-weight: 400;
    src: url('fonts/lato/lato-v14-latin-italic.eot'); /* IE9 Compat Modes */
    src: local('Lato Italic'), local('Lato-Italic'),
    url('fonts/lato/lato-v14-latin-italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/lato/lato-v14-latin-italic.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/lato/lato-v14-latin-italic.woff') format('woff'), /* Modern Browsers */
    url('fonts/lato/lato-v14-latin-italic.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/lato/lato-v14-latin-italic.svg#Lato') format('svg'); /* Legacy iOS */
  }
  /* open-sans-300 - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    src: url('fonts/open-sans/open-sans-v15-latin-300.eot'); /* IE9 Compat Modes */
    src: local('Open Sans Light'), local('OpenSans-Light'),
    url('fonts/open-sans/open-sans-v15-latin-300.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/open-sans/open-sans-v15-latin-300.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-300.woff') format('woff'), /* Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-300.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/open-sans/open-sans-v15-latin-300.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-300italic - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: italic;
    font-weight: 300;
    src: url('fonts/open-sans/open-sans-v15-latin-300italic.eot'); /* IE9 Compat Modes */
    src: local('Open Sans Light Italic'), local('OpenSans-LightItalic'),
    url('fonts/open-sans/open-sans-v15-latin-300italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/open-sans/open-sans-v15-latin-300italic.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-300italic.woff') format('woff'), /* Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-300italic.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/open-sans/open-sans-v15-latin-300italic.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-regular - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    src: url('fonts/open-sans/open-sans-v15-latin-regular.eot'); /* IE9 Compat Modes */
    src: local('Open Sans Regular'), local('OpenSans-Regular'),
    url('fonts/open-sans/open-sans-v15-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/open-sans/open-sans-v15-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-regular.woff') format('woff'), /* Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/open-sans/open-sans-v15-latin-regular.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-italic - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: italic;
    font-weight: 400;
    src: url('fonts/open-sans/open-sans-v15-latin-italic.eot'); /* IE9 Compat Modes */
    src: local('Open Sans Italic'), local('OpenSans-Italic'),
    url('fonts/open-sans/open-sans-v15-latin-italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/open-sans/open-sans-v15-latin-italic.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-italic.woff') format('woff'), /* Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-italic.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/open-sans/open-sans-v15-latin-italic.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-600 - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    src: url('fonts/open-sans/open-sans-v15-latin-600.eot'); /* IE9 Compat Modes */
    src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'),
    url('fonts/open-sans/open-sans-v15-latin-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/open-sans/open-sans-v15-latin-600.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-600.woff') format('woff'), /* Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-600.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/open-sans/open-sans-v15-latin-600.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

  /* open-sans-600italic - latin */
  @font-face {
    font-family: 'Open Sans';
    font-style: italic;
    font-weight: 600;
    src: url('fonts/open-sans/open-sans-v15-latin-600italic.eot'); /* IE9 Compat Modes */
    src: local('Open Sans SemiBold Italic'), local('OpenSans-SemiBoldItalic'),
    url('fonts/open-sans/open-sans-v15-latin-600italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('fonts/open-sans/open-sans-v15-latin-600italic.woff2') format('woff2'), /* Super Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-600italic.woff') format('woff'), /* Modern Browsers */
    url('fonts/open-sans/open-sans-v15-latin-600italic.ttf') format('truetype'), /* Safari, Android, iOS */
    url('fonts/open-sans/open-sans-v15-latin-600italic.svg#OpenSans') format('svg'); /* Legacy iOS */
  }

</style>
